'use strict';

import { generateUniqueNumber } from 'app_vodafone_ziggo/util/util';
import { appendDataToName } from '../util/gtm';
import { goToStep, transitionToStep } from '../util/spa';
import { statementHistoryUpdate } from '../steps/statements';

/**
 * @public pushHistoryState
 */
function pushHistoryState() {
    this.targetStepName = this.targetStep.getAttribute(this.attributes.stepName);
    this.targetStepId = this.targetStep.getAttribute(this.attributes.stepId);

    // If there is a target step name
    if (this.targetStepName) {
        this.targetStepName = this.targetStepName.replace(/\s/g, '-');
        this.historySequence = !this.goingBack ? this.historySequence + 1 : this.historySequence - 1;
        this.lastHistorySequence = this.historySequence;

        // If it's not the statements page, push the state
        // There's a separate `pushStatementHistoryState` for the statements page
        if (!this.targetStep.classList.contains(this.classes.statements.container)) {
            const uniqueStepIndex = `${this.targetStepIndex}__${generateUniqueNumber()}`;
            this.stepsOrder.push(uniqueStepIndex);
            this.targetStepName = appendDataToName(this.targetStepId, this.targetStepName, this.currentStepName);

            window.history.pushState(
                {
                    html: null,
                    sequence: this.historySequence,
                    stepIndex: uniqueStepIndex,
                    pageTitle: `${this.baseTitle} - ${this.targetStepName}`
                },
                null,
                `${this.baseUrl}?${this.targetStepName}`
            );
        }
    }
}

/**
 * @public addHistoryListeners
 */
function addHistoryListeners() {
    // On page load, push an empty state if the url does not contain an utm code.
    // In case the user reloads the page while being in one of the history's earlier states, this will remove subsequent history states.
    // In other words, it will remove the "forward" option from the browser history on page load which can cause for weird scenario's.
    const utmCode = window.location.href.split('utm=');
    const disableUrlUpdate = this.mainContainer.hasAttribute(this.attributes.disableUrlUpdate);

    if (utmCode.length < 2 && !disableUrlUpdate && this.baseUrl !== 'null') {
        window.history.pushState({}, null, this.baseUrl);
    }

    window.addEventListener(this.CONST.events.popstate, (event) => {
        const pageTitle = event.state && event.state.pageTitle;
        this.historyChange = true;
        this.transitionDelay = 0;

        if (pageTitle) {
            this.goingBack = event.state.sequence < this.lastHistorySequence;

            if (event.state.stepIndex) {
                goToStep.call(this, event); // eslint-disable-line no-use-before-define
                this.lastHistorySequence = event.state.sequence;
            } else if (event.state.statementId) {
                const statementsStep = document.querySelector(this.selectors.statementsStep);

                if (!statementsStep.classList.contains(this.CONST.classes.active)) {
                    this.targetStep = statementsStep;
                    this.targetStepIndex = this.targetStep.getAttribute(this.attributes.stepIndex);
                    transitionToStep.call(this);
                    this.lastHistorySequence = event.state.sequence;
                }

                const trimmedStatementId = event.state.statementId.split('__')[0];
                statementHistoryUpdate.call(this, trimmedStatementId);
            }
        } else {
            // If we have no state information, it must be the starting page
            this.targetStep = this.firstStep;
            this.targetStepIndex = this.firstStepIndex;

            transitionToStep.call(this);
        }
    });
}

export { pushHistoryState, addHistoryListeners };
